/// <amd-module name="Artifacts/Root/types/IMinimalPackageVersion" />

/**
 * IMinimalPackageVersion is the interface that provides minimal set of data to show package version list.
 */
export interface IMinimalPackageVersion {
  /**
   * Id for the package version.
   */
  id: string;
  /**
   * UTC Date the package was published to the service.
   */
  publishDate: Date;
  /**
   * Display version number.
   */
  version: string;
  /**
   * List of view names package has been promoted to.
   */
  views: string[];
  /**
   * Description of the package version.
   */
  description: string;
  /**
   * GUID of the upstream source this package was ingested from.
   */
  directUpstreamSourceId?: string;
}
